<template>
  <Modal
    :id="'dtplugins-dbox_costs-cost_form'"
    @cancelled="onCancel"
  >
    <template slot="header"
      >{{ title }} {{ itemName }}
    </template>
    <template slot="body">
      <div class="body-container">
        <div
          class="form-group"
          style="
            max-height: 600px;
            overflow-y: auto;
            padding-right: 32px;
            margin-right: -32px;
          "
        >
          <TextField
            :id="'date'"
            class="m1"
            v-bind="textFieldConfig"
            type="date"
            v-model="cost.date"
            isModel
            required
            showValidationIcons
            :placeholder="$t('reporting_date')"
            @valuechanged="onTextFieldValueChange"
            :disabled="formDisabled"
          />
          <TextField
            :id="'description'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="cost.description"
            isModel
            required
            showValidationIcons
            :placeholder="$t('description')"
            @valuechanged="onTextFieldValueChange"
            :disabled="formDisabled"
          />
          <Dropdown
            :id="'type'"
            class="m2"
            :options="cost_groupsTV"
            :disabled="formDisabled"
            :selected="
              cost_groupsTV.find(
                (e) => e.value == cost.cost_group_id
              )
            "
            :placeholder="$t(groupName)"
            box
            @selectedChange="
              (e) => onDropdownChange('cost_group_id', e)
            "
            showValidationIcons
            required
            immediateValidation
            @validated="(e) => onValidation('cost_group_id', e)"
          ></Dropdown>
          <Dropdown
            :id="'type'"
            class="m2"
            :options="currenciesTV"
            :disabled="formDisabled"
            :selected="
              currenciesTV.find((e) => e.value == cost.currency)
            "
            :placeholder="$t('currency')"
            box
            @selectedChange="(e) => onCurrencyChange(e)"
          ></Dropdown>

          <TextField
            :id="'amount_orig_curr'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="cost.amount_orig_curr"
            isModel
            :placeholder="$t('amount_original_currency')"
            @valuechanged="onTextFieldValueChange"
            :disabled="formDisabled"
            :type="'number'"
            @blur="onOriginalCurrencyBlur"
          />
          <TextField
            :id="'exchange_rate'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="cost.exchange_rate"
            isModel
            :placeholder="$t('exchange_rate')"
            @valuechanged="onExchangeRateTextFieldValueChange"
            :disabled="formDisabled"
          />
          <TextField
            :id="'amount'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="cost.amount"
            isModel
            :placeholder="
              $t('amount') +
              ' ' +
              (details && details.client_default_currency)
            "
            @valuechanged="onTextFieldValueChange"
            :disabled="formDisabled"
          />
          <br />
          <template v-if="believe_special">
            <TextField
              :id="'payment_date'"
              class="m1"
              type="date"
              v-bind="textFieldConfig"
              v-model="cost.payment_date"
              isModel
              :placeholder="$t('payment_date')"
              @valuechanged="onTextFieldValueChange"
            />
            <TextField
              :id="'posting_description'"
              class="m1"
              v-bind="textFieldConfig"
              v-model="cost.json_data.posting_description"
              isModel
              :placeholder="$t('posting_description')"
              :disabled="formDisabled"
            />
            <TextField
              :id="'rep_grp_2'"
              class="m1"
              v-bind="textFieldConfig"
              v-model="cost.json_data.rep_grp_2"
              isModel
              :placeholder="$t('rep_grp_2')"
              :disabled="formDisabled"
            />
            <TextField
              :id="'rep_grp_3'"
              class="m1"
              v-bind="textFieldConfig"
              v-model="cost.json_data.rep_grp_3"
              isModel
              :placeholder="$t('rep_grp_3')"
              :disabled="formDisabled"
            />
            <Dropdown
              :id="'type'"
              class="m2"
              :options="currenciesTV"
              :disabled="formDisabled"
              :selected="
                currenciesTV.find(
                  (e) =>
                    e.value ==
                    cost.json_data.referential_currency
                )
              "
              :placeholder="$t('referential_currency')"
              box
              deselect
              @selectedChange="
                (e) =>
                  onJsonDataDropdownChange(
                    'referential_currency',
                    e
                  )
              "
            />
            <TextField
              :id="'referential_amount'"
              class="m1"
              v-bind="textFieldConfig"
              v-model="cost.json_data.referential_amount"
              isModel
              :disabled="formDisabled"
              :placeholder="$t('referential_amount')"
            />
            <br />
            <TextField
              :id="'id_project'"
              class="m1"
              v-bind="textFieldConfig"
              v-model="cost.json_data.id_project"
              isModel
              :disabled="formDisabled"
              :placeholder="$t('project_id')"
            />
            <TextField
              :id="'contract_type'"
              class="m1"
              v-bind="textFieldConfig"
              v-model="cost.json_data.contract_type"
              isModel
              :disabled="formDisabled"
              :placeholder="$t('contract_type')"
            />
            <TextField
              :id="'id_prod'"
              class="m1"
              v-bind="textFieldConfig"
              v-model="cost.json_data.id_prod"
              isModel
              :disabled="formDisabled"
              :placeholder="$t('id_prod')"
            />
            <Dropdown
              :id="'type'"
              class="m2"
              :options="companiesTV"
              :disabled="formDisabled"
              :selected="
                companiesTV.find(
                  (e) => e.value == cost.json_data.company
                )
              "
              :placeholder="$t('company')"
              box
              deselect
              @selectedChange="
                (e) => onJsonDataDropdownChange('company', e)
              "
            ></Dropdown>
            <TextField
              :id="'recharge_code'"
              class="m1"
              v-bind="textFieldConfig"
              v-model="cost.json_data.recharge_code"
              isModel
              :placeholder="$t('recharge_code')"
              @valuechanged="onTextFieldValueChange"
              :disabled="formDisabled"
            />
            <Dropdown
              :id="'type'"
              class="m2"
              :options="cost_centersTV"
              :disabled="formDisabled"
              :selected="
                cost_centersTV.find(
                  (e) => e.value == cost.json_data.cost_center
                )
              "
              :placeholder="$t('cost_center')"
              box
              deselect
              @selectedChange="
                (e) =>
                  onJsonDataDropdownChange('cost_center', e)
              "
            ></Dropdown>
            <TextField
              :id="'destination'"
              class="m1"
              v-bind="textFieldConfig"
              v-model="cost.json_data.destination"
              isModel
              :disabled="formDisabled"
              :placeholder="$t('destination')"
            />
            <TextField
              :id="'social_account'"
              class="m1"
              v-bind="textFieldConfig"
              v-model="cost.json_data.social_account"
              isModel
              :disabled="formDisabled"
              :placeholder="$t('social_account')"
            />
            <Dropdown
              :id="'details_recharge_type'"
              class="m2"
              :options="recharge_typesTV"
              :disabled="formDisabled"
              :selected="
                recharge_typesTV.find(
                  (e) =>
                    e.value ==
                    cost.json_data.details_recharge_type
                )
              "
              :placeholder="$t('recharge_type')"
              box
              deselect
              @selectedChange="
                (e) =>
                  onJsonDataDropdownChange(
                    'details_recharge_type',
                    e
                  )
              "
            ></Dropdown>
            <TextField
              :id="'posting_type'"
              class="m1"
              v-bind="textFieldConfig"
              v-model="cost.json_data.posting_type"
              isModel
              :disabled="formDisabled"
              :placeholder="$t('posting_type')"
            />
            <TextField
              :id="'posting_number'"
              class="m1"
              v-bind="textFieldConfig"
              v-model="cost.json_data.posting_number"
              isModel
              :placeholder="$t('posting_number')"
              @valuechanged="onPostingNumberChange"
              :disabled="formDisabled"
              showValidationIcons
              required
              :validators="postingNumberValidators"
              @validated="onValidation"
            />
            <TextField
              :id="'site'"
              class="m1"
              v-bind="textFieldConfig"
              v-model="cost.json_data.site"
              isModel
              :disabled="formDisabled"
              :placeholder="$t('site')"
            />
            <TextField
              :id="'accounting_date'"
              class="m1"
              v-bind="textFieldConfig"
              v-model="cost.json_data.accounting_date"
              isModel
              :disabled="formDisabled"
              :placeholder="$t('accounting_date')"
            />
            <TextField
              :id="'referential'"
              class="m1"
              v-bind="textFieldConfig"
              v-model="cost.json_data.referential"
              isModel
              :disabled="formDisabled"
              :placeholder="$t('referential')"
            />
            <TextField
              :id="'analytical_account'"
              class="m1"
              v-bind="textFieldConfig"
              v-model="cost.json_data.analytical_account"
              isModel
              :disabled="formDisabled"
              :placeholder="$t('analytical_account')"
            />
            <TextField
              :id="'rep_account'"
              class="m1"
              v-bind="textFieldConfig"
              isModel
              :placeholder="$t('rep_account')"
              @valuechanged="onTextFieldValueChange"
              :disabled="formDisabled"
            />
          </template>
          <template v-else>
            <TextField
              :id="'company'"
              class="m1"
              v-bind="textFieldConfig"
              v-model="cost.company"
              isModel
              :placeholder="$t('company')"
              @valuechanged="onTextFieldValueChange"
              :disabled="formDisabled"
            />
            <TextField
              :id="'document_ref'"
              class="m1"
              v-bind="textFieldConfig"
              v-model="cost.document_ref"
              isModel
              :placeholder="$t('document_ref')"
              @valuechanged="onTextFieldValueChange"
              :disabled="formDisabled"
            />
            <TextField
              :id="'payment_date'"
              type="date"
              class="m1"
              v-bind="textFieldConfig"
              v-model="cost.payment_date"
              isModel
              :placeholder="$t('payment_date')"
              @valuechanged="onTextFieldValueChange"
            />
          </template>
        </div>
      </div>
    </template>

    <template slot="options">
     
      <button class="dt-button s6" @click.stop="onCancel">
        Cancel
      </button>
       <button
        :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
        class="dt-button v1 s6"
        @click.stop="onOkClick"
      >
        Ok
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import InputField from "@plugins/text-field/input-field";
import NTable from "@/plugins/datatable/datatable";
import { DBoxCostService } from "./dbox-costs.service";
import { createTV } from "../../models/text-value.model";
import {
  createFormItemMixin,
  createFormModalMixin,
} from "../form-modal/form-modal";
import { isValidNumber, subscribeSubject } from "../../utility";
import { createValidator } from "../../plugins/text-field";
import { Subject } from "rxjs";
 

export default {
  components: {
    Modal,
    InputField,
    NTable,
  },
  props: ["itemName", "config", "cost_groupsTV","groupName"],
  mixins: [
    createFormModalMixin(),
    createFormItemMixin({
      primary_key: "cost_split_id",
      itemKey: "cost",
      detailsHttpReq: DBoxCostService.getCostDetails,
      addHttpReq: DBoxCostService.getAddCostData,
      processAddHttpResMethod: "processAddHttpResMethod",
    }),
  ],
  mounted() {
    subscribeSubject(
      this,
      this.postingNumberSubject,
      async (value) => {
        const checkUnique = await DBoxCostService.checkPostingNumber(
          {
            external_id: this.config.primaryKeyValue,
            external_table: this.config.externalTable,
            cost_split_id: this.cost_split_id,
            posting_number: value,
          }
        );

        const is_unique = checkUnique.data.is_unique;
        // console.log({
        //   "this.validationResult": this.validationResult,
        // });
        if (!is_unique) {
          // console.log({ is_unique: is_unique });
          this.duplicatePostingNumber = value;
          const temp = this.cost.json_data.posting_number;
          this.cost.json_data.posting_number = null;
          this.$nextTick(() => {
            this.cost.json_data.posting_number = temp;
          });
        }
      }
    );
  },
  data() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        immediateValidation: true,
      },
      validationResult: {},

      postingNumberSubject: new Subject(),
      duplicatePostingNumber: 0,
    };
  },
  computed: {
    trackCreditTypesTV: function () {
      return createTV(
        this.details && this.details.track_credit_types,
        "en",
        "key"
      );
    },
    currencies() {
      return this.details?.["currencies"];
    },
    currenciesTV() {
      return createTV(
        this.currencies || [],
        "currency_name",
        "currency_iso"
      );
    },
    cost_split_id: function () {
      return this.$route.query.cost_split_id;
    },
    believe_special() {
      // console.log(this.$store.getters.account.believe_special);
      return this.$store.getters.account.believe_special;
    },
    isFormValid: function () {
      return Object.values(this.validationResult).every(
        (e) => e.valid
      );
    },
    postingNumberValidators() {
      return [
        createValidator({
          name: "postingNumberUniq",
          validatorFn: this.checkPostingNumberUniq,
          errorMessage:
            "This posting number is already in the system!",
        }),
      ];
    },
    companies() {
      return this.details?.companies || [];
    },
    companiesTV() {
      return createTV(
        this.companies,
        "company_name",
        "company_code"
      );
    },
    cost_centers() {
      return this.details?.cost_centers || [];
    },
    cost_centersTV() {
      return createTV(
        this.cost_centers,
        "cost_center_name",
        "cost_center_code"
      );
    },
    recharge_typesTV() {
      return [
        {
          text: "Expense",
          value: "expense",
        },
        {
          text: "Recharge",
          value: "recharge",
        },
      ];
    },

    formDisabled() {
      return this.details?.balances?.length > 0;
    },
  },
  methods: {
    onOkClick: async function () {
      // console.log(this.cost);
      if (this.mode == "add") {
        this.$emit("added", this.cost);
      } else if (this.mode == "edit") {
        this.$emit("edited", this.cost);
      }
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    get_cost: function () {
      return {
        account_to_promoter_flag: null,
        accounting_date: null,
        advance_type_id: null,
        amount_orig_curr: null,
        amount: null,
        amount2: null,
        channel_id: null,
        company: null,
        cost_group_id: null,
        cost_id: null,
        cost_split_id: null,
        created: null,
        currency: null,
        date: null,
        description: null,
        document_ref: null,
        exchange_rate: null,
        external_data1: null,
        external_data2: null,
        external_data3: null,
        external_data4: null,
        external_id: null,
        external_id2: null,
        external_table: null,
        external_table2: null,
        file_id: null,
        hold_flag: null,
        identifier: null,
        invoice_id: null,
        invoice_line_id: null,
        json_data: {
          site: null,
          cost_center: null,
          destination: null,
          social_account: null,
          posting_number: null,
          rep_grp_2: null,
          contract_type: null,
          accounting_date: null,
          rep_account: null,
          referential_amount: null,
          recharge_code: null,
          details_recharge_type: null,
          rep_grp_3: null,
          id_prod: null,
          analytical_account: null,
          posting_type: null,
          company: null,
          referential_currency: null,
          id_project: null,
          referential: null,
          posting_description: null,
        },
        last_modified: null,
        manual_recoupment_flag: null,
        marketing_type_id: null,
        paid_by_promoter_flag: null,
        payment_date: null,
        qty: null,
        recouped_flag: null,
        statement_line_id: null,
      };
    },

    onOriginalCurrencyBlur(name, value) {
      const selectedCurrency = this.currencies.find(
        (e) => e.currency_iso == this.cost.currency
      );
      const ex_rate = selectedCurrency.exchange_rate;

      if (isValidNumber(ex_rate)) {
        this.cost = {
          ...this.cost,
          amount_orig_curr: value,
          amount: (value / ex_rate).toFixed(3),
          exchange_rate: ex_rate,
        };
        // console.log({
        //   "this.cost.amount": this.cost["amount"],
        // });
      }
    },
    onExchangeRateTextFieldValueChange(name, value) {
      if (isValidNumber(value)) {
        this.cost = {
          ...this.cost,
          amount: (this.cost.amount_orig_curr / value).toFixed(
            3
          ),
          exchange_rate: value,
        };
      }
    },
    onCurrencyChange(value) {
      const selectedCurrency = this.currencies.find(
        (e) => e.currency_iso == value.value
      );
      if (!selectedCurrency) {
        this.cost = {
          ...this.cost,
          amount: "",
          exchange_rate: "",
        };
        return;
      }

      this.cost = {
        ...this.cost,
        currency: value.value,
        amount: (
          this.cost.amount_orig_curr /
          selectedCurrency.exchange_rate
        ).toFixed(3),
        exchange_rate: selectedCurrency.exchange_rate,
      };
    },
    processAddHttpResMethod() {
      this.cost.currency =
        this.details?.client_default_currency || "EUR";
    },
    async onPostingNumberChange(name, value) {
      this.cost.posting_number = value;
      this.postingNumberSubject.next(value);
    },
    checkPostingNumberUniq(value) {
      return value == this.duplicatePostingNumber
        ? false
        : true;
    },
    onJsonDataDropdownChange(name, value) {
      // console.log({ "name, value": name, value });
      this.cost.json_data[name] = value.value;
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.dtplugins-dbox_costs-cost_form {
  .form-group {
    /* padding-right: 32px; */
  }
}
</style>


